import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

const CategoryItemTypeForm = ({ state, updateField, errors }) => {
    return (
        <Box p={4} display="flex" justifyContent="center">
            <Grid container spacing={1}>

                {/*  */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        fullWidth
                        label="Περιγραφή"
                        value={state?.pcit_descr || ""}
                        onChange={e => updateField("pcit_descr", e.target.value)}
                        error={!!errors.pcit_descr}
                        helperText={errors.pcit_descr}
                    />
                </Grid>

                {/*  */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        fullWidth
                        label="A/A"
                        value={state?.pcit_aa || ""}
                        onChange={e => updateField("pcit_aa", Number(e.target.value))}
                        error={!!errors.pcit_aa}
                        helperText={errors.pcit_aa}
                    />
                </Grid>

            </Grid>
        </Box>
    );
};

export default CategoryItemTypeForm;
